import { Component, OnDestroy } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { AvmFileCounterPipe } from '@hub4b/pipes/avm-file-counter.pipe';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FolderCounterEventsService } from 'src/app/services/events/folder-counter-events.service';
import { BoxesStateService } from 'src/app/services/state/boxes-state.service';

@Component({
    selector: 'app-boxes-summary',
    templateUrl: './boxes-summary.component.html',
    styleUrls: ['./boxes-summary.component.scss'],
    imports: [MatBadgeModule, AvmFileCounterPipe]
})
export class BoxesSummaryComponent implements OnDestroy {
    /**
     * Utilisé pour gérer la désincription des observables lorsque le composant est détruit.
     */
    protected componentDestroyed$: Subject<void> = new Subject<void>();

    /**
     * Valeur du compteur affichant le nombre de bannettes sélectionnées.
     */
    public selectedBoxesCount: string = '…';

    /**
     * Valeur du compteur affichant le nombre de dossiers affichés.
     */
    public displayedFoldersCount: string = '…';

    /**
	 * Constructeur.
	 * @param boxesStateService

	 */
    constructor(
        private boxesStateService: BoxesStateService,
        private folderCounterEventsService: FolderCounterEventsService
    ) {
        /** Abonnement aux événements de changement de selection de bannettes. */
        this.boxesStateService.onBoxesSelectionChange$.pipe(takeUntil(this.componentDestroyed$)).subscribe((change) => {
            if (!!change) {
                this.selectedBoxesCount = this.boxesStateService.getSelectedBoxes().length.toString();
            }
        });

        /** Abonnement aux événements de changement de compteur de dossiers */
        this.folderCounterEventsService.displayedFoldersCounterUpdated.pipe(takeUntil(this.componentDestroyed$)).subscribe((event) => {
            this.displayedFoldersCount = event.count.toString();
        });
    }

    /**
     * Appelée à la destruction du composant.
     */
    ngOnDestroy(): void {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
}
